import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { getValetOrderInfo } from '@/business/confirmOrder'
import { PREFIX_STRADE } from '@/service'
const api = {
  confirmUrl: PREFIX_STRADE + 'confirmOrder.do',
  order: PREFIX_STRADE + 'createOrder.do',
  coupon: `${utils.hostname('coupon')}/omnicoupon/GetConfirmCoupons`
}

export default {
  async getConfirmProduct({ commit }, query) {
    try {
      const valetOrderInfo = await getValetOrderInfo()
      if (valetOrderInfo) {
        commit('setConfirmProduct', valetOrderInfo || {})
      } else {
        let q = JSON.parse(query)
        q.businesstype = 21
        const product_res = await fetch(
          `${api.confirmUrl}?param=${JSON.stringify(q)}`
        )
        const productJSON = await product_res.json()
        // Todo
        // productJSON.data.skuInfo.skuTag = 2
        if (productJSON.data) {
          commit('setConfirmProduct', productJSON.data || {})
        }
        return productJSON
      }
    } catch (e) {
      throw new Error(e)
    }
  },
  async createOrder({ commit }, params) {
    try {
      // 育儿必传21  自营摄影24
      params.businesstype = params.isSelfPhoto === true ? 24 : 21
      const order = await fetch(`${api.order}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: `param=${encodeURIComponent(JSON.stringify(params))}`
        // credentials: 'include',
      })
      const orderJSON = await order.json()
      if (orderJSON.code === '1') {
        return orderJSON
      }
      return orderJSON
    } catch (e) {
      console.log(e)
    }
  },
  async getCoupons(
    { commit },
    { uid, skey, items, channelid, entityid, source }
  ) {
    try {
      const query_param = {
        uid,
        skey,
        items,
        source,
        channelid,
        entityid,
        businesstype: 4
      }
      const query = queryString.stringify(query_param)
      const coupon_res = await fetch(`${api.coupon}?${query}`)
      const couponJson = await coupon_res.json()
      if (couponJson.errno === 0) {
        commit('setCouponList', couponJson.data.availableCoupons || [])
      }
      // return workers
    } catch (e) {
      console.log(e)
    }
  },
  async getIsOpenAppCashier({ commit }) {
    try {
      const res = await fetch('//cms.cekid.com/publish/999/appCashierSet.json')
      const response = await res.json()
      if (response && response.data && !!response.data.isOpen) {
        commit('setIsOpenAppCashier', true)
      }
    } catch (e) {
      console.log(e)
    }
  }
}
